import { render, staticRenderFns } from "./FormCostoPerRicavo.vue?vue&type=template&id=7e849052&"
import script from "./FormCostoPerRicavo.vue?vue&type=script&lang=js&"
export * from "./FormCostoPerRicavo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports